import { Component, OnInit } from '@angular/core';

import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router, Scroll } from '@angular/router';
import { filter } from 'rxjs/operators';
import { scrollToFragment, scrollToTop } from './scrollto';

/**
 * This component is used to scroll to a segment based on the navigation.
 * It is used to scroll to a segment based on the navigation.
 * In Case of no fragment, it will scroll to the top.
 *
 *   provideRouter(
 *      appRoutes,
 *      withRouterConfig({
 *          paramsInheritanceStrategy: 'always',
 *          onSameUrlNavigation: 'reload',
 *      }),
 *      withInMemoryScrolling({
 *          scrollPositionRestoration: 'disabled',
 *          anchorScrolling: 'disabled',
 *      })
 *  ),
 *
 *
 */
@Component({
    selector: 'gsap-scroll-to-segment-based-on-navigation',
    template: ``,
})
export class GsapScrollToSegmentBasedOnNavigationComponent implements OnInit {
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private platform = inject(PLATFORM_ID);
    private flag = false;

    ngOnInit(): void {
        this.router.events.pipe(filter((event) => event instanceof Scroll)).subscribe((event) => {
            const fragment = this.route.snapshot.fragment;

            if (fragment) {
                // Wait for DOM to be ready before scrolling
                requestAnimationFrame(() => {
                    scrollToFragment('#' + fragment, this.platform, 'power2.in');
                    setTimeout(() => {
                        scrollToFragment('#' + fragment, this.platform, 'power2.out');
                    }, 300);
                });
            }
            // do not trigger scrollToTop on first time
            else if (this.flag) {
                scrollToTop(this.platform);
            }
            this.flag = true;
        });
    }
}
